import { ClientAuth, Device } from '@/classes';
import { Content } from '@/types';
import { stringify } from 'qs';

interface ToPlayerPathProps {
  content: Pick<Content, 'id' | 'cursor'>;
  sourcePage: string;
  containerId?: number;
}

export const ContentPlayback = {
  isLocked: (content: Pick<Content, 'accessScope'>) =>
    !ClientAuth.user?.isSubscriber && content.accessScope === 'SUBSCRIBER',

  progressOf: (id: number) => {
    const history = Device.getHistory(id);
    return history ? Math.round((history.duration / history.totalDuration) * 100) : 0;
  },

  toPlayerPath: ({ content, sourcePage, containerId }: ToPlayerPathProps) =>
    `/videos?${stringify({ id: content.id, cursor: content.cursor, source_page: sourcePage, container_id: containerId })}`,
};
